import { Box } from "@mui/material";
import { HotelSearchBar } from "../Availability/Search/HotelSearchBar";

export const HotelSearchPrimaryColor = () => {
  return <Box
    bgcolor="primary.main"
    display="flex"
    gap={2}
    px={2}
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    minHeight={134}>
    <HotelSearchBar />
  </Box>;
};
